import * as mutationService from './mutationService';

const changeSetting = (state, payload) => {
  state.setting = { ...state.setting, ...payload };
};

const changeLoading = (state, payload) => {
  state.loading = payload;
};

const changePingData = (state, payload) => {
  state.pingData = payload;
};

const changeIframes = (state, payload) => {
  state.iframes = payload;
};

const changeAppDetails = (state, payload) => {
  state.appDetails = payload;
};

const changeAppDetailsStatus = (state, payload) => {
  const appName = payload.service;
  const isEnabled = payload.isEnabled;
  const appDetailIndex = state.appDetails.findIndex(app => app.service == appName);
  if (appDetailIndex == undefined) {
    state.appDetails[appDetailIndex].is_enabled = isEnabled;
  }
};

const changeMqttConfig = (state, payload) => {
  state.mqttConfig = { ...state.mqttConfig, ...payload };
};

const changeInstalledServices = (state, payload) => {
  state.installedServices = payload;
};

const changeMbNetworksData = (state, payload) => {
  state.mbNetworks = payload;
};

const changeServicesConfigured = (state, payload) => {
  state.isServicesConfigured = { ...state.isServicesConfigured, ...payload };
};

const changeRdNetworksData = (state, payload) => {
  state.rdNetworks = payload;
};

const changeMqttRestBridgeConfig = (state, payload = {}) => {
  state.mqttRestBridgeConfig = { ...payload };
  state.isMaster = (payload && payload.master) || false;
};

const changeBulkAppDownloadState = (state, payload) => {
  state.currentBulkAppDownloadState = payload;
};

const changeBmNetworksData = (state, payload) => {
  state.bmNetworks = payload;
};

const changeSwitchedSlaveState = (state, payload) => {
  state.isSwitchedSlave = payload;
};

const changeAppRerenderCount = state => {
  state.rerenderCount = state.rerenderCount++;
};

function getUUIds(items) {
  return (items || []).map(item => item.uuid);
}

const changeRfCommandGroups = (state, payload) => {
  state.rfCommandGroupsUUIDs = getUUIds(payload);
  state.rfCommandGroups = payload;
};

const changeRfStreams = (state, payload) => {
  state.rfStreams = payload;
};

const changeRfFlowNetworks = (state, payload) => {
  state.rfFlowNetworks = payload;
};

const changeRfWriters = (state, payload) => {
  state.rfWriters = payload;
};

const changeRfNetworks = (state, payload) => {
  state.rfNetworks = payload;
};

const changeRfDevices = (state, payload) => {
  state.rfDevices = payload;
};

const changeRfPoints = (state, payload) => {
  state.rfPoints = payload;
};

const showOverlay = state => {
  state.showOverlay = true;
};

const hideOverlay = state => {
  state.showOverlay = false;
};

const changeRfPlugins = (state, payload) => {
  state.rfPlugins = payload;
};

const changeRFAvailable = (state, payload) => {
  state.rfAvailable = payload;
};

const updateFlowNetworkCloneSearch = (state, payload) => {
  state.flowNetworkCloneSearch = payload;
};

const updateFlowNetworkSearch = (state, payload) => {
  state.flowNetworkSearch = payload;
};

const updateFlowNetworkNavigationNames = (state, payload) => {
  state.flowNetworkNamesMap = mutationService.constructFlowNetworkNames(payload);
};

const updateFlowNetworkCloneNavigationNames = (state, payload) => {
  state.flowNetworkCloneNamesMap = mutationService.constructFlowNetworkCloneNames(payload);
};

const updateNetworksNavigationNames = (state, payload) => {
  state.networkNamesMap = mutationService.contructNetworkNames(payload);
};

export default {
  updateNetworksNavigationNames,
  updateFlowNetworkNavigationNames,
  updateFlowNetworkCloneNavigationNames,
  changeRFAvailable,
  changeRfPlugins,
  showOverlay,
  hideOverlay,
  changeRfWriters,
  changeRfFlowNetworks,
  changeRfCommandGroups,
  changeRfStreams,
  changeRfNetworks,
  changeRfDevices,
  changeRfPoints,
  changeSetting,
  changeSwitchedSlaveState,
  changeAppRerenderCount,
  changePingData,
  changeLoading,
  changeIframes,
  changeAppDetails,
  changeMqttConfig,
  changeMbNetworksData,
  changeRdNetworksData,
  changeAppDetailsStatus,
  changeInstalledServices,
  changeServicesConfigured,
  changeBulkAppDownloadState,
  changeMqttRestBridgeConfig,
  changeBmNetworksData,
  updateFlowNetworkCloneSearch,
  updateFlowNetworkSearch,
};
